import { IDataForRoomsIsAccepted } from '../../../actions/bookingCalendar/room/requestDataForRooms'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IDataForRoomsIsAccepted,
): IBookingCalendarStore {
  const updatedIds = action.rooms.map(room => room.id)

  return {
    ...state,
    request: {
      ...state.request,
      rooms: {
        errMessage: '',
        isLoading: false,
      },
    },
    rooms: action.clear
      ? []
      : [
          ...state.rooms.filter(r => !updatedIds.includes(r.id)),
          ...action.rooms,
        ],
  }
}
